'use client'

import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function LogoutButton() {
    const { logout, user } = useAuth();
    console.log('User:', logout);
    
    const handleLogout = () => {
      logout();
      window.location.href = '/login';
    };

    const handleLogin = () => {
      window.location.href = '/login';
    };
  
    return (
      <Button 
        onClick={user?.isLoggedIn ? handleLogout : handleLogin}
        variant="outline"
        className="ml-auto"
      >
        {user?.isLoggedIn ? 'Logout' : 'Login'}
      </Button>
    );
}